import { Component, Input, OnInit } from '@angular/core';
import { QrGeneratorAudio } from '@app/store/models/qr-generator-audio.interface';
import { SocialHelper } from '@app/store/models/social-helper.interface';
import { QrGeneratorNavigatorMP3 } from 'shared-library';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';
import { UserQrGeneratorService } from 'src/app/modules/user/services/user-qr-generator.service';

@Component({
  selector: 'app-qrs-mp3',
  templateUrl: './qrs-mp3.component.html',
  styleUrls: ['./qrs-mp3.component.scss', '../qrs-wrapper.component.scss']
})
export class QrsMp3Component implements OnInit {

  audio: QrGeneratorAudio
  supported_browser = !!this.qrGeneratorService.initiateAudioPlayer()


  @Input() qr_url: string;
  @Input() social_data: SocialHelper
  @Input() data: QrGeneratorNavigatorMP3

  constructor(
    public readonly functionService: FunctionsService,
    public readonly qrGeneratorService: UserQrGeneratorService
  ) { }

  ngOnInit(): void {
    this.functionService.initializeTooltip()
    this.audio = this.qrGeneratorService.fillAudioPlayer(this.data.mp3.url, this.audio)
  }

  playSound() {
    if (this.audio.playing) {
      this.audio.playing = false
      this.audio.player.pause()
      return
    }
    this.audio.playing = true
    this.audio.player.play()
  }


  async downloadAudio() {
    if (this.audio.downloading) return
    this.audio.downloading = true
    let link = document.createElement('a')
    link.target = "_blank"
    link.href = this.data.mp3.url
    link.download = (this.data.mp3.name || "untitled_audio") + '.mp3'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    this.audio.downloading = false
  }


}
